module.exports = __webpack_public_path__ + "nc_static/media/dd_water_parameters.44de26e1.svg";